// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"870":"77585cac","879":"b655d609","916":"118e759f","924":"bdbca15e"}[chunkId] + ".js";
};